import { Features } from '@tock/coretypes';
import { TicketType } from 'generated/graphql';
import { TypePolicies } from '@apollo/client';

/**
 * This function computes an object suitable for spreading into the typePolicies:
 * argument for the Apollo InMemoryCache() constructor. Specifically, we can configure
 * what fake data to provide based on feature flag settings, which is cool and useful.
 *
 * @param features the relevant features object, probably extracted directly from
 *   store state
 */
export function computeFakeDataTypePolicies(features: Features): TypePolicies {
  return {
    // Currently, there is no data being mocked through Apollo. The below example shows how a mock might be set up for
    // a particular query / fields (Timeline in this case)
    //
    // Timeline: {
    //   fields: {
    //     ticketTypes: {
    //       read: createFakeTicketTypes,
    //     },
    //   },
    // },
  };
}

/**
 * Creates fake data to plug in where the schema's TicketType[] definition can be used.
 */
export function createFakeTicketTypes(): TicketType[] {
  return [
    {
      id: 33,
      name: 'The greatest experience this restaurant offers',
      shortCode: 'GRRT',
      variety: 'DEPOSIT',
    },
    {
      id: 44,
      name: 'A medium-quality experience',
      shortCode: 'MID',
      variety: 'DEPOSIT',
    },
    {
      id: 55,
      name: 'The least-good-best-experience',
      shortCode: 'LGB',
      variety: 'DEPOSIT',
    },
  ];
}
